var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-inner-loading',{attrs:{"showing":true}},[_c('q-spinner-dots',{attrs:{"size":"200px","color":"np-primary-1100"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }